<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>Advanced/Dual-Credit Courses Taken</b> - The percentage of students who complete and receive credit for at least one advanced or dual-credit course.
    </v-card-text>
  </v-card>
</template>
